<app-header></app-header>

<!-- ======= Hero Section ======= -->
<section id="hero" class="hero_slide">
    <div data-bs-interval="5000" class="" data-bs-ride="carousel">
        <!-- Slide 1 -->
        <div class="container">
            <div class="row">
                <div class="col-lg-6 col-md-6 slider-left-text mt-3 cust-slider-left-text pad_top_30">
                    <h2 class="animate__animated animate__fadeInDown text-alignment-center pt-1 pb-4">About RMS</h2>
                    <p class="animate__animated animate__fadeInUp width-100 m-0 text_jus1">RMS gathers Real-Time data
                        from machines & sends it to the cloud. It comes with both web & Mobile Applications. The
                        application offers custom reporting & custom dashboard generation by the user itself. It helps
                        in anomaly detection & sends at least when certain events occur.</p>
                    <div class="flex_center pad-top-25">
                        <a href="https://www.samyak.com/contact-us/"
                            class="btn-get-started animate__animated animate__fadeInUp scrollto margin-top-25 cursor_pointer">Explore
                            More</a>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 text-right">
                    <img src="assets/img/about-us-header.svg" class="slider-img-level slider-img">
                </div>
            </div>


        </div>
    </div>
</section><!-- End Hero -->

<main id="main">

    <section id="clients" class="clients">
        <div class="container p-0">


            <div class="row client-logo-main">

                <div class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
                    <img src="assets/img/Adani-power-logo.svg" class="img-fluid" alt="">
                </div>

                <div class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
                    <img src="assets/img/Cognitive Technologies.svg" class="img-fluid" alt="">
                </div>

                <div class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
                    <img src="assets/img/Anodyne Technologies.svg" class="img-fluid" alt="">
                </div>

                <div class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
                    <img src="assets/img/Energy Doctor (Tricolite Energy Soln).svg" class="img-fluid" alt="">
                </div>

                <div class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
                    <img src="assets/img/Navi mumbai corporation.svg" class="img-fluid" alt="">
                </div>

                <div class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
                    <img src="assets/img/rech.svg" class="img-fluid" alt="">
                </div>

            </div>

        </div>
    </section>

    <section id="clients" class="pb-4">
        <div data-bs-interval="5000" class="" data-bs-ride="carousel">
            <!-- Slide 1 -->
            <div class="container">
                <div class="row pad_15">

                    <div class="col-lg-6 col-md-6">
                        <img src="assets/img/about-us-img.svg">
                    </div>
                    <div class="col-lg-6 col-md-6 mt-3 pb-5 cust-slider-left-text">
                        <h2 class="text-left text-about">About Samyak Infotech & Samyak
                            instrumentation
                        </h2>
                        <p class="paragraph_text text_jus">Software part of RMS is developed by Samyak Infotech and
                            hardware part of RMS is developed by Samyak Instrumentation. Samyak Infotech is into IT
                            services industry since 1998. It works with fortune 500 companies as well. Samyak Infotech
                            is ISO 9001:2015 certified and Microsoft Silver Partner. Samyak Instrumentation focuses on
                            industrial automation products. Combining strength of both the firms Samyak have served a
                            lot of manufacturing firms for their plant monitoring, automation, digitization and custom
                            software development.
                        </p>

                    </div>
                </div>


            </div>
        </div>
    </section>

    <section id="testimonials" class="industries testimonials services pad_top_60">
        <div class="container aos-init aos-animate" data-aos="fade-up">

            <div class="text-center">

                <p>RMS Web and Mobile App</p>
            </div>

            <div class="align-items-center text-center justify-content-center">
                <img class="img_bgimage" src="assets/img/about_us_img.svg" alt="">
            </div>


        </div>
    </section>

    <section id="clients" class="padding-top-new-2 padding-bottom-new-2">
        <div data-bs-interval="5000" class="" data-bs-ride="carousel">
            <!-- Slide 1 -->
            <div class="container pad_27">
                <div class="row">


                    <div class="col-lg-6 col-md-6 slider-left-text cust-slider-left-text">
                        <h2 class="text-left text-about">How to Join Us?</h2>
                        <p class="paragraph_text">Just fill out this form with your details and we will get in touch
                            with you. We will discuss your detailed requirement and suggest solution accordingly. We
                            provide both hardware and software so you don't need to deal with multiple agencies.
                        </p>

                        <div class="text_center_11 contact_button_flex"> <button mat-button color="primary"
                                class="contact_button1 font-white button_text" style="width: 125px; height: 35px;"><a
                                    href="https://www.samyak.com/contact-us/"
                                    style="color: #FFFFFF;">Contact</a></button></div>



                    </div>

                    <div class="col-lg-6 col-md-6 text-right pt-4">
                        <img src="assets/img/about-us-img2.svg">
                    </div>
                </div>


            </div>
        </div>
    </section>


    <section id="clients" class="padding-top-new-1 section-bg">
        <div data-bs-interval="5000" class="" data-bs-ride="carousel">
            <!-- Slide 1 -->
            <div class="container">
                <div class="row">

                    <h2 class="section-title pb-3">Data Processing & Alerting</h2>

                    <div class="pb-5" style="display: flex; padding-top:30px;">
                        <div><img src="assets/img/mobile_img_1_update.svg"></div>
                        <div><img src="assets/img/mobile_img2.svg" style="padding-top: 50px;"></div>
                        <div><img src="assets/img/mobile_img3.svg"></div>
                        <div><img src="assets/img/mobile_img4.svg" style="padding-top: 50px;"></div>
                        <div><img src="assets/img/mobile_img5.svg"></div>
                    </div>

                </div>


            </div>
        </div>
    </section>


    <section id="testimonial-area" class="pt-5 padding-bottom-new">

        <div class="container">
            <div class="mx-auto">
                <header class="section-header text-center">
  
                    <h2  class="m_top">What our Customers are Saying</h2>
                </header>
            </div>
            <div class="testimonial-block" style="padding-bottom: 40px; padding-top: 45px;">
                <div style="width: 428px;" class="image_display"><img src="assets/img/user5.svg" alt=""
                        class="testimonial_img"></div>
  
                <div class="padding-both-side">
  
                    <h1> <span><img src="../../assets/img/comma.svg" class="commam"></span></h1>
                    <p class="text_align_center" style="font-size: 14px;">“Samyak's support is really good and we are
                        very happy with the services they have provided to us like hardware data integration through GSM
                        gateways. Two way communication is helping us a big time. We heartily appreciate all kind of
                        support.”</p>
                    <div class="testimonial">
                        <p class="testimonialFrom text_align_center" style="font-size: 14px;">Jummal Popis</p>
                        <p class="text_align_center" style="font-size: 14px;">Founder Circle</p>
                    </div>
                </div>
            </div>
  
  
  
        </div>
  
    </section>
  


</main>

<app-footer></app-footer>